import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import AppBarSelector from './Pages/AppBarSelector';
import { VendorList } from './Component/Assessor/VendorList';
import VendorProfile from './Component/Vendor/VendorProfile';
import ChangePass from './Pages/ChangePass';
import MasterData from './Component/Vendor/MasterData';
import Forgot from './Pages/Forgot';
import Login from './Pages/Login';
import MonthlyDataClient from './Component/Client/MonthlydataClient';
import MasterdataTableAssessor from '../src/Component/Assessor/MasterdataTableAssessor';
import AdminClient from './Component/Admin/AdminClient';
import AsessorVendor from './Component/Assessor/AssessorVendor';
// import Company from './Pages/Company';
import AdminAssessor from './Component/Admin/AdminAssessor';
import Clientdashboard from './Pages/Dashboard/Client/vendorCompliance';
import Vendordashboard from './Pages/Dashboard/Vendor';
import Admindashboard from './Pages/Dashboard/Admin';
import Corporatedashboard from './Pages/Dashboard/Corporate/vendorCompliance';
import AssesorDashboard from './Pages/Dashboard/Assessor/vendorCompliance';
import { AssessorProfile } from './Component/Assessor/AssessorProfile';
// import MasterdataTableAdmin from './Component/MasterdataTableAdmin';
import { AssessorList } from './Component/Admin/AssessorList';
import { ClientList } from './Component/Admin/ClientList';
import { ClientProfile } from './Component/Client/ClientProfile';
import MasterdataTableClient from './Component/Client/MasterdataTableClient';
import MonthlyData from './Component/Vendor/MonthlyData';
import { EstablishmentMonthlydataCreatePage } from './Component/Assessor/CreateEstablishmentMonthlydata';
import MonthlyDataTableAssessor from './Component/Assessor/MonthlyDataTableAssessor';
import MonthlyDataTableClient from './Component/Client/MonthlyDataTableClient';
import MonthlyReport from './Component/MonthlyReport';
import LandingPage from './Pages/Website/LandingPage';
import AboutUs from './Pages/Website/AboutUs';
import MonthlydataEstablishment from './Component/Assessor/MonthlydataEstablishment';
import PrivacyAndPolicy from './Pages/Website/PrivacyAndPolicy';
import ContactUs from './Pages/Website/ContactUs';
import EstablishmentComplianceService from './Pages/Website/EstablishmentComplianceService';
import VendorCompliance from './Pages/Website/VendorCompliance';
import FactoryComplianceService from './Pages/Website/FactoryCompliance';
import HrServiceProviderAuditService from './Pages/Website/HrServiceProviderAudit';
import PayrollManagement from './Pages/Website/PayrollManagement';
import NewLabourCodes from './Pages/Website/NewLabourCodes';
import ProductivityAudit from './Pages/Website/ProductivityAudit';
import Demo from './Pages/Website/Demo';
import MasterDataClient from './Component/Client/MasterDataClient';
import FAQs from './Pages/Website/FAQs';
import PrivateRoute from './Services/PrivateRoute';
import AdminCorporate from './Component/Admin/AdminCorporate';
// import { createTheme } from '@mui/material/styles';
import Terms from './Pages/Website/TermsAndConditions';
import ComplianceCalendar from './Pages/ComplianceCalender';
import CoporateList from './Component/Admin/CoporateList';
import ClientsList from './Component/Corporate/ClientList';
import { CorporateProfile } from './Component/Corporate/CoporateProfile';
// import MinimumWages from './Pages/Website/MinimumWages';
import MinWages from './Pages/Website/MinWages';
import MinimumWagesManagement from './Pages/admin/MinimumWagesManagement';
// import MasterdataTableAdmin from './Component/MasterdataTableAdmin';
// import LabourActs from './Pages/LabourActs';
import HolidayList from './Pages/HolidayList';
// import GazetteNotifications from './Pages/GazetteNotifications';
// import LeavePolicy from './Pages/LeavePolicy';
import LabourWelfareFund from './Pages/LabourWelfareFund';
// import MinimumWage from './Pages/MinimumWage';
import ProfessionalTax from './Pages/ProfessionalTax';
// import ProvidentFunds from './Pages/ProvidentFunds';
import RegistrationLicenseServices from './Pages/Website/RegistrationLicenseServices';
import IndustryTypeManagement from './Pages/admin/IndustryTypeManagement';
import Updates from './Pages/admin/Updates';
import UploadHolidayList from './Pages/admin/HolidayList/UploadHolidayList';
import MasterDataTableEstablishment from './Component/Assessor/MasterdataTableEstablishment';
import ESTreport from './Component/Client/ClientMonthlyReport'
import ReportCorporate from './Pages/Dashboard/Corporate/establishmentCompliance/EstablishmentDetails'
import Estdashboard from './Pages/Dashboard/Client/establishmentCompliance/ClientIndex'
import AssessorEstablishmentDashboard from './Pages/Dashboard/Assessor/establishmentCompliance/AssessorEstablishmentDashboard'
// const theme = createTheme({
//   typography: {
//     fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
//   },
// });
import EstablsihmentAvrgMasterdata from './Pages/Dashboard/Corporate/establishmentCompliance/establishmentMasterAvrg'
import ActsRulesPage from './Pages/admin/Acts_Rules/ActsRulesPage';
const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { pathname } = useLocation();
  const hideAppBarRoutes = [
    "/", "/login", "/about-us", "/services", "/faqs", "/contact-us",
    "/services/establishment-compliance",
    "/services/factory-compliance",
    "/services/hr-service-provider-audit",
    "/services/payroll-management",
    "/services/new-labour-laws",
    "/services/productivity-audit",
    "/services/vendor-compliance",
    "/request-a-demo",
    "/terms-and-condition",
    "/services/registration",
    "/minimum-wages",
    "/minimum-wages/wage-management",
    "/minimum-wages/view",
    "/privacy-policy",
    "/elibary",
    "/labour-acts",
    "/forms",
    "/hoilday-list",
    "/gazette-notifications",
    "/leave-policies",
    "/labour-welfare-fund",
    "/professional-tax",
    "/provident-funds",
  ];

  const normalizePath = (path) => path.toLowerCase().replace(/\/+$/, '') || '/';
  const currentPath = normalizePath(pathname);
  const shouldHideAppBar = hideAppBarRoutes.includes(currentPath);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);


  const MainRoutes = () => (
    <Routes>
      {/* common  */}
      <Route path="/signin" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
      <Route path="/report" element={<PrivateRoute element={<MonthlyReport />} isLoggedIn={isLoggedIn} />} />
      <Route path='/complience-calender' element={<PrivateRoute element={<ComplianceCalendar />} isLoggedIn={isLoggedIn} />} />
      <Route path='/forgotPassword' element={<Forgot setIsLoggedIn={setIsLoggedIn} />} />


      {/* admin */}
      <Route path="/createCompany" element={<PrivateRoute element={<AdminClient />} isLoggedIn={isLoggedIn} />} />
      <Route path="/createAssessor" element={<PrivateRoute element={<AdminAssessor />} isLoggedIn={isLoggedIn} />} />
      <Route path="/changePass" element={<PrivateRoute element={<ChangePass />} isLoggedIn={isLoggedIn} />} />
      <Route path="/admindashboard" element={<PrivateRoute element={<Admindashboard />} isLoggedIn={isLoggedIn} />} />
      <Route path="/createCorporate" element={<PrivateRoute element={<AdminCorporate />} isLoggedIn={isLoggedIn} />} />
      <Route path="/corporateList" element={<PrivateRoute element={<CoporateList />} isLoggedIn={isLoggedIn} />} />
      <Route path="/establishmentsList" element={<PrivateRoute element={<ClientList />} isLoggedIn={isLoggedIn} />} />
      <Route path="/assessorList" element={<PrivateRoute element={<AssessorList />} isLoggedIn={isLoggedIn} />} />
      <Route path="/minimum-wages-management" element={<PrivateRoute element={<MinimumWagesManagement />} isLoggedIn={isLoggedIn} />} />
      <Route path="/industry-type-management" element={<PrivateRoute element={<IndustryTypeManagement />} isLoggedIn={isLoggedIn} />} />
      <Route path="/updates" element={<PrivateRoute element={<Updates />} isLoggedIn={isLoggedIn} />} />
      <Route path="/holidayList" element={<PrivateRoute element={<UploadHolidayList />} isLoggedIn={isLoggedIn} />} />
      <Route path="/acts" element={<PrivateRoute element={<ActsRulesPage />} isLoggedIn={isLoggedIn} />} />
      <Route path="/rules" element={<PrivateRoute element={<ActsRulesPage />} isLoggedIn={isLoggedIn} />} />





      {/* corporate  */}
      <Route path="/corporatedashboard" element={<PrivateRoute element={<Corporatedashboard />} isLoggedIn={isLoggedIn} />} />
      <Route path="/establishmentList" element={<PrivateRoute element={<ClientsList />} isLoggedIn={isLoggedIn} />} />
      <Route path="/corporate/profile" element={<PrivateRoute element={<CorporateProfile />} isLoggedIn={isLoggedIn} />} />
      <Route path="/cor/report" element={<PrivateRoute element={<ReportCorporate />} isLoggedIn={isLoggedIn} />} />
      <Route path="/establishmentcorporatedashboard" element={<PrivateRoute element={<EstablsihmentAvrgMasterdata />} isLoggedIn={isLoggedIn} />} />


      {/* client  */}
      <Route path="/establishmentVendordashboard" element={<PrivateRoute element={<Clientdashboard />} isLoggedIn={isLoggedIn} />} />
      <Route path="/vendors-masterData" element={<PrivateRoute element={<MasterdataTableClient />} isLoggedIn={isLoggedIn} />} />
      <Route path="/client/profile" element={<PrivateRoute element={<ClientProfile />} isLoggedIn={isLoggedIn} />} />
      <Route path="/vendors-monthlyData" element={<PrivateRoute element={<MonthlyDataTableClient />} isLoggedIn={isLoggedIn} />} />
      
      <Route path="/master-data" element={<PrivateRoute element={<MasterDataClient />} isLoggedIn={isLoggedIn} />} />
      <Route path="/monthly-data" element={<PrivateRoute element={<MonthlyDataClient />} isLoggedIn={isLoggedIn} />} />
            <Route path='/est-report' element={<PrivateRoute element={<ESTreport />} isLoggedIn={isLoggedIn}/>}></Route>
      <Route path="/establishmentdashboard" element={<PrivateRoute element={<Estdashboard />} isLoggedIn={isLoggedIn} />} />


      {/* assessor */}
      <Route path="/assessorestablishmentdashboard" element={<PrivateRoute element={<AssessorEstablishmentDashboard />} isLoggedIn={isLoggedIn} />} />

      <Route path="/createVendor" element={<PrivateRoute element={<AsessorVendor />} isLoggedIn={isLoggedIn} />} />
      <Route path="/profile/assessor" element={<PrivateRoute element={<AssessorProfile />} isLoggedIn={isLoggedIn} />} />
      <Route path="/assessordashboard" element={<PrivateRoute element={<AssesorDashboard />} isLoggedIn={isLoggedIn} />} />
      <Route path="/vendorsMonthlyData" element={<PrivateRoute element={<MonthlyDataTableAssessor />} isLoggedIn={isLoggedIn} />} />
      <Route path="/forgotPassword" element={<PrivateRoute element={<Forgot />} isLoggedIn={isLoggedIn} />} />
      <Route path="/vendorsList" element={<PrivateRoute element={<VendorList />} isLoggedIn={isLoggedIn} />} />
      <Route path="/vendorsMasterData" element={<PrivateRoute element={<MasterdataTableAssessor />} isLoggedIn={isLoggedIn} />} />
      <Route path="/establishmentMasterData" element={<PrivateRoute element={<MasterDataTableEstablishment />} isLoggedIn={isLoggedIn} />} />
      <Route path="/establishmentMonthlydataCreatePage" element={<PrivateRoute element={<EstablishmentMonthlydataCreatePage/>} isLoggedIn={isLoggedIn}/>}/>
      <Route path="/establishmentMonthlydata" element={<PrivateRoute element={<MonthlydataEstablishment/>} isLoggedIn={isLoggedIn}/>}/>      


      {/* vendor  */}
      <Route path="/profile/vendor" element={<PrivateRoute element={<VendorProfile />} isLoggedIn={isLoggedIn} />} />
      <Route path="/vendordashboard" element={<PrivateRoute element={<Vendordashboard />} isLoggedIn={isLoggedIn} />} />
      <Route path="/masterdata" element={<PrivateRoute element={<MasterData />} isLoggedIn={isLoggedIn} />} />
      <Route path="/MonthlyData" element={<PrivateRoute element={<MonthlyData />} isLoggedIn={isLoggedIn} />} />
    </Routes>
  );

  return (
    <>

      {!shouldHideAppBar && (
        <AppBarSelector>
          <MainRoutes />
        </AppBarSelector>
      )}

      <Routes>
        <Route path="/" element={<LandingPage />} />
        {/* Redirect from LandingPage to Login */}
        {/* <Route path="/landing" element={<Navigate to="/login" />} /> */}
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/FAQs" element={<FAQs />} />
        <Route path="/services/establishment-compliance" element={<EstablishmentComplianceService />} />
        <Route path="/services/vendor-compliance" element={<VendorCompliance />} />
        <Route path="/services/factory-compliance" element={<FactoryComplianceService />} />
        <Route path="/services/hr-service-provider-audit" element={<HrServiceProviderAuditService />} />
        <Route path="/services/payroll-management" element={<PayrollManagement />} />
        <Route path="/services/new-labour-laws" element={<NewLabourCodes />} />
        <Route path="/services/productivity-audit" element={<ProductivityAudit />} />
        <Route path="/services/registration" element={<RegistrationLicenseServices />} />
        <Route path="/request-a-demo" element={<Demo />} />
        <Route path="/terms-and-condition" element={<Terms />} />
        {/* <Route path="/complience-calender" element={ <ComplianceCalendar/> } /> */}
        <Route path='/privacy-policy' element={<PrivacyAndPolicy />} />
        {/* <Route path='/minimum-wages' element={<MinimumWages />} /> */}
        <Route path='/minimum-wages/view' element={<MinWages />} />
        {/* <Route path="/labour-acts" element={<LabourActs />} /> */}
        <Route path="/hoilday-list" element={<HolidayList />} />
        {/* <Route path="/gazette-notifications" element={<GazetteNotifications />} /> */}
        {/* <Route path="/leave-policies" element={<LeavePolicy />} /> */}
        {/* <Route path="/labour-welfare-fund" element={<LabourWelfareFund />} /> */}
        {/* <Route path="/minimum-wages" element={<MinimumWage />} /> */}
        {/* <Route path="/professional-tax" element={<ProfessionalTax />} /> */}
        {/* <Route path="/provident-funds" element={<ProvidentFunds />} /> */}
        <Route path="/home" element={<LandingPage />} />
      </Routes>
    </>
  );
};

export default App;
